<al-auth-flow-modal></al-auth-flow-modal>

<div class="backDrop" *ngIf="showDialog$ | async" title="">
    <div class="modal-dialog modal-s">
        <div class="modal-content">
            <div>
                <div class="modal-header ">
                    <h4 class="modal-title">Login details</h4>
                </div>

                <div class="modal-body">
					<div class="form-group">
						<div class="row">
							<ng-container *ngFor="let param of appParams.parameters; index as i">
                                <!-- Primary parameters with no underlying elements -->
                                <div class="col-lg-6" *ngIf="!param.underlyingElements || !formGroup.get(param?.fieldName)?.value">
                                    <app-link-edit-application-login-fields [param]="param" [formGroup]="formGroup" [index]="i"></app-link-edit-application-login-fields>
                                </div>

                                <!-- Parameters with underlying elements -->
                                <ng-container *ngIf="param.underlyingElements && formGroup.get(param?.fieldName)?.value">
                                    <!-- Main parameter without col-lg-6 -->
                                    <div class="col-lg-6">
                                        <app-link-edit-application-login-fields [param]="param" [formGroup]="formGroup" [index]="i"></app-link-edit-application-login-fields>
                                    </div>
                                    <!-- Nested underlying elements with col-lg-6 -->
                                    <ng-container *ngFor="let element of param.underlyingElements">
                                        <div class="col-lg-6">
                                            <app-link-edit-application-login-fields [param]="element" [formGroup]="formGroup" [index]="i"></app-link-edit-application-login-fields>
                                        </div>
                                    </ng-container>
                                </ng-container>
							</ng-container>

						</div>
					</div>
					<!-- removed at Ezra's request. considered not intuitive for users, as this requires saving the login first.
                    <al-link-edit-application-login-auth [formGroup]="formGroup" [linkId]="linkId" [appSide]="appSide" [fromLinkType]="fromLinkType" [applicationId]="applicationId" [appParams]="appParams"
                    [disabledLoginBtnSubject]="disabledLoginBtnSubject" [saveAction]="saveAction" [checkForm]="true"></al-link-edit-application-login-auth> -->
                </div>

                <div class="modal-footer">
                    <button [disabled]="disabledLoginBtnObservable | async" type="button" class="btn btn-success" (click)="savebtn()">
						Save
					</button>
                    <button type="button" class="btn btn-primary" (click)="cancel()">
						Cancel
					</button>
                </div>
            </div>
        </div>
    </div>
</div>
